import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// TODO: USER - Replace with your Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyCV6X5SGhedEAjJOWevy3e-nu-OQqoHJV8",
  authDomain: "devlusaja-com.firebaseapp.com",
  projectId: "devlusaja-com",
  storageBucket: "devlusaja-com.firebasestorage.app",
  messagingSenderId: "738837079744",
  appId: "1:738837079744:web:0c79655d965ec75433af25"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth };